import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
export function MarketingHero() {
  const [activeRow, setActiveRow] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveRow(prev => (prev + 1) % 3);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  const contacts = [{
    company_name: 'Sunrise bakery & cafe',
    owner: 'S. Jenkins, Owner',
    email: 'info@sunrisebakery.com',
    phone: '(415) 555-0123',
    industry: 'Food & Beverage'
  }, {
    company_name: 'City auto repair',
    owner: 'M. Chen, Owner',
    email: 'service@cityauto.com',
    phone: '(312) 555-0456',
    industry: 'Automotive'
  }, {
    company_name: 'Metro beauty salon',
    owner: 'E. Rodriguez, Owner',
    email: 'booking@metrobeauty.com',
    phone: '(213) 555-0789',
    industry: 'Personal Care'
  }];
  return <section className="relative pt-16 pb-24 overflow-hidden bg-white" data-id="element-4933">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-4934">
        <a href="#/features" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-slate-900 transition-colors mb-8" data-id="element-4935">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-4936" /> All features
        </a>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-4937">
          {/* Left Column: Copy & CTAs */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-4938">
            <h1 className="text-6xl sm:text-7xl lg:text-[5.5rem] font-bold tracking-tight text-slate-900 mb-8 leading-[1.05]" data-id="element-4939">
              Local <br data-id="element-4940" />
              <span className="text-blue-600" data-id="element-4941">business</span> <br data-id="element-4942" />
              marketing
            </h1>

            <p className="text-xl sm:text-2xl text-slate-600 mb-8 max-w-lg leading-relaxed" data-id="element-4943">
              Turn local business data into high-converting Meta Ads (Facebook
              Ads) campaigns. Get{' '}
              <span className="inline-flex items-center px-4 py-1 rounded-full bg-blue-50 text-blue-700 text-lg sm:text-xl font-medium mx-1" data-id="element-4944">
                owner emails
              </span>
              ,{' '}
              <span className="inline-flex items-center px-4 py-1 rounded-full bg-green-50 text-green-700 text-lg sm:text-xl font-medium mx-1" data-id="element-4945">
                ad platform audiences
              </span>
              , and{' '}
              <span className="inline-flex items-center px-4 py-1 rounded-full bg-purple-50 text-purple-700 text-lg sm:text-xl font-medium mx-1 mt-2 sm:mt-0" data-id="element-4946">
                local business contacts
              </span>{' '}
              in minutes with Openmart.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-4947">
              <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="px-10 py-4 text-white font-bold bg-blue-600 rounded-full hover:bg-blue-700 transition-colors text-lg text-center" data-id="element-4948">
                Try for free
              </a>
            </div>

            {/* Static Stats Bar */}
            <div className="flex gap-12 pt-8" data-id="element-4949">
              <div data-id="element-4950">
                <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-4951">
                  200M+
                </div>
                <div className="text-sm text-slate-500 font-medium" data-id="element-4952">
                  Local businesses across 10+ countries
                </div>
              </div>
              <div data-id="element-4953">
                <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-4954">
                  50+
                </div>
                <div className="text-sm text-slate-500 font-medium" data-id="element-4955">
                  Data fields
                </div>
              </div>
              <div data-id="element-4956">
                <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-4957">
                  100%
                </div>
                <div className="text-sm text-slate-500 font-medium" data-id="element-4958">
                  Ad platform ready
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right Column: Live Data Preview Card */}
          <div className="relative" data-id="element-4959">
            <div className="bg-slate-50 rounded-[2rem] p-8 sm:p-10 relative z-10" data-id="element-4960">
              <div className="flex justify-between items-center mb-8" data-id="element-4961">
                <h3 className="text-2xl font-bold text-slate-900" data-id="element-4962">
                  Enriched local business contacts
                </h3>
              </div>

              <div className="overflow-x-auto" data-id="element-4963">
                <table className="w-full text-sm text-left" data-id="element-4964">
                  <thead data-id="element-4965">
                    <tr className="text-slate-400 font-medium border-b border-slate-200/60" data-id="element-4966">
                      <th className="pb-4 pl-4 pr-4 font-medium" data-id="element-4967">
                        Local business
                      </th>
                      <th className="pb-4 px-4 font-medium" data-id="element-4968">Owner contact</th>
                      <th className="pb-4 pl-4 font-medium" data-id="element-4969">Email</th>
                      <th className="pb-4 pl-4 font-medium hidden sm:table-cell" data-id="element-4970">
                        Industry
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-200/60" data-id="element-4971">
                    {contacts.map((contact, idx) => <tr key={idx} className={`transition-all duration-500 relative ${activeRow === idx ? 'bg-white shadow-sm rounded-xl' : ''}`} data-id="element-4972">
                        <td className="py-6 pl-4 pr-4 font-medium text-slate-900 rounded-l-xl" data-id="element-4973">
                          {contact.company_name}
                          <div className="text-xs text-slate-500 font-normal mt-1 sm:hidden" data-id="element-4974">
                            {contact.industry}
                          </div>
                        </td>
                        <td className="py-6 px-4 text-slate-600" data-id="element-4975">
                          <div className="whitespace-nowrap" data-id="element-4976">
                            {contact.owner}
                          </div>
                          <div className="text-xs text-slate-500 mt-0.5" data-id="element-4977">
                            {contact.phone}
                          </div>
                        </td>
                        <td className="py-6 pl-4 text-blue-600 truncate max-w-[120px] sm:max-w-none" data-id="element-4978">
                          {contact.email}
                        </td>
                        <td className="py-6 pl-4 hidden sm:table-cell rounded-r-xl" data-id="element-4979">
                          <span className="text-slate-600 font-medium" data-id="element-4980">
                            {contact.industry}
                          </span>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>

              {/* Export button */}
              <div className="mt-8 pt-6 border-t border-slate-200/60 flex justify-end" data-id="element-4981">
                <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 bg-slate-900 text-white text-sm font-semibold rounded-lg hover:bg-slate-800 transition-colors" data-id="element-4982">
                  Export audience
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}